import React from 'react';
import { Avatar, Typography, withStyles } from '@material-ui/core';
import Search from '@material-ui/icons/Search';

const styles = (theme) => ({
  layout: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center',
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
});

class NadaEcontrado extends React.PureComponent {
  render () {
    const { classes, mensagem } = this.props;
    return (
      <React.Fragment>
        <div className={classes.layout}>
          <Avatar>
            <Search />
          </Avatar>
          <Typography fontWeight={600}>{mensagem || `Nenhum resultado`}</Typography>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(NadaEcontrado);
